(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-1"]) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section-header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-2"]) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section-header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-3"]) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section-header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  if (!window.vsGiftCleanup) {
    window.vsGiftCleanup = true;
    let vsCleaning = false;

    const vsIsKachingGift = (item) => {
      const raw = item.properties && item.properties.__kaching_bundles;
      if (!raw) return false;
      try {
        return Boolean(JSON.parse(raw).gift);
      } catch (error) {
        return false;
      }
    };

    const vsFindPaidGifts = (cart) => (cart.items || [])
      .filter((item) => vsIsKachingGift(item) && item.final_line_price > 0)
      .map((item) => {
        const discounted = item.original_line_price - item.final_line_price;
        const freeUnits = item.original_price > 0 ? Math.floor(discounted / item.original_price) : 0;
        return { key: item.key, quantity: Math.max(0, Math.min(freeUnits, item.quantity - 1)) };
      });

    const vsCleanGifts = async (cart) => {
      if (vsCleaning) return;
      const fixes = vsFindPaidGifts(cart);
      if (!fixes.length) return;
      vsCleaning = true;
      try {
        const routes = (window.themeVariables && window.themeVariables.routes) || {};
        const changeUrl = (routes.cartChangeUrl || '/cart/change') + '.js';
        for (const fix of fixes) {
          const response = await fetch(changeUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: fix.key, quantity: fix.quantity }),
          });
          if (!response.ok) return;
        }
        const settings = (window.themeVariables && window.themeVariables.settings) || {};
        if (settings.pageType === 'cart') {
          window.location.reload();
          return;
        }
        await new Promise((resolve) => setTimeout(resolve, 800));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: {} }));
        const fresh = await (await fetch((routes.cartUrl || '/cart') + '.js', { credentials: 'same-origin' })).json();
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: fresh } }));
      } catch (error) {
      } finally {
        vsCleaning = false;
      }
    };

    document.documentElement.addEventListener('cart:updated', (event) => {
      if (event.detail && event.detail.cart && event.detail.cart.items) {
        vsCleanGifts(event.detail.cart);
      } else {
        fetch('/cart.js', { credentials: 'same-origin' }).then((response) => response.json()).then(vsCleanGifts).catch(() => {});
      }
    });

    fetch('/cart.js', { credentials: 'same-origin' }).then((response) => response.json()).then(vsCleanGifts).catch(() => {});
  }

  if (!customElements.get('vs-bundle-nudge')) {
    const vsDealCache = {};

    const vsReadDealsFromHtml = (html, productId) => {
      const pattern = new RegExp('<script[^>]*class="kaching-bundles-deal-block-settings"[^>]*data-product-id="' + productId + '"[^>]*>([\\s\\S]*?)</script>');
      const match = html.match(pattern);
      if (!match) return [];
      try {
        const settings = JSON.parse(match[1]);
        return (settings.dealBars || [])
          .filter((bar) => bar.dealBarType === 'quantity-break' && bar.quantity)
          .map((bar) => ({ quantity: Number(bar.quantity), type: bar.discountType, value: Number(bar.discountValue) }))
          .sort((a, b) => a.quantity - b.quantity);
      } catch (error) {
        return [];
      }
    };

    const vsGetDeals = (productId, productUrl) => {
      if (vsDealCache[productId]) return vsDealCache[productId];
      const storageKey = 'vs-kaching-deals-' + productId;
      try {
        const stored = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        if (stored && Date.now() - stored.time < 3600000) {
          vsDealCache[productId] = Promise.resolve(stored.deals);
          return vsDealCache[productId];
        }
      } catch (error) {}
      const onPage = document.querySelector('script.kaching-bundles-deal-block-settings[data-product-id="' + productId + '"]');
      const source = onPage
        ? Promise.resolve(vsReadDealsFromHtml(onPage.outerHTML, productId))
        : fetch(productUrl, { credentials: 'same-origin' }).then((response) => (response.ok ? response.text() : '')).then((html) => vsReadDealsFromHtml(html, productId)).catch(() => []);
      vsDealCache[productId] = source.then((deals) => {
        try {
          sessionStorage.setItem(storageKey, JSON.stringify({ time: Date.now(), deals }));
        } catch (error) {}
        return deals;
      });
      return vsDealCache[productId];
    };

    const vsFormatMoney = (cents) => {
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency }).format(cents / 100);
    };

    customElements.define('vs-bundle-nudge', class extends HTMLElement {
      connectedCallback() {
        const productId = this.dataset.productId;
        const quantity = Number(this.dataset.quantity);
        const unitPrice = Number(this.dataset.unitPrice);
        const linePrice = Number(this.dataset.linePrice);
        if (!productId || !quantity || !unitPrice) return;
        vsGetDeals(productId, this.dataset.productUrl).then((deals) => {
          if (!this.isConnected) return;
          const next = deals.find((deal) => deal.quantity > quantity);
          if (!next) return;
          let nextTotal = null;
          if (next.type === 'specific' && next.value > 0) nextTotal = Math.round(next.value * 100);
          if (next.type === 'default') nextTotal = unitPrice * next.quantity;
          if (nextTotal === null) return;
          const fullPrice = unitPrice * next.quantity;
          const extraCost = nextTotal - linePrice;
          const saving = fullPrice - nextTotal;
          if (saving <= 0 || extraCost <= 0) return;
          this.render(next.quantity, next.quantity - quantity, extraCost, nextTotal, saving);
        });
      }

      render(nextQuantity, extraUnits, extraCost, nextTotal, saving) {
        const text = document.createElement('p');
        text.className = 'vs-bundle-nudge__text';
        const headline = document.createElement('strong');
        headline.textContent = 'Add ' + extraUnits + ' more for only ' + vsFormatMoney(extraCost);
        const sub = document.createElement('span');
        sub.className = 'vs-bundle-nudge__sub';
        sub.textContent = nextQuantity + ' for ' + vsFormatMoney(nextTotal) + ', you save ' + vsFormatMoney(saving);
        text.append(headline, sub);

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'vs-bundle-nudge__add';
        button.textContent = '+ Add';
        button.setAttribute('aria-label', 'Add ' + extraUnits + ' more for ' + vsFormatMoney(extraCost));
        button.addEventListener('click', () => {
          const drawer = this.closest('ap-cartdrawer') || this.closest('form') || document;
          const input = drawer.querySelector('input[name="updates[]"][data-line="' + this.dataset.line + '"]');
          if (!input) return;
          button.disabled = true;
          input.value = nextQuantity;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        this.replaceChildren(text, button);
        this.hidden = false;
      }
    });
  }

  if (!customElements.get('vs-cart-discount')) {
    const vsCartRoute = () => ((window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl) || '/cart');
    const vsSameCode = (a, b) => String(a).toLowerCase() === String(b).toLowerCase();

    customElements.define('vs-cart-discount', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('.vs-discount__form');
        this.input = this.querySelector('.vs-discount__input');
        this.button = this.querySelector('.vs-discount__apply');
        this.error = this.querySelector('.vs-discount__error');
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.apply();
        });
        this.querySelectorAll('.vs-discount__remove').forEach((button) => {
          button.addEventListener('click', () => this.remove(button.dataset.code, button));
        });
      }

      showError(message) {
        this.error.textContent = message;
        this.error.hidden = !message;
      }

      setBusy(busy) {
        this.button.disabled = busy;
        this.input.disabled = busy;
      }

      async currentCodes() {
        const response = await fetch(vsCartRoute() + '.js', { credentials: 'same-origin' });
        const cart = await response.json();
        return (cart.discount_codes || []).filter((entry) => entry.applicable).map((entry) => entry.code);
      }

      async update(codes) {
        const response = await fetch(vsCartRoute() + '/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(','), sections: 'mini-cart' }),
        });
        if (!response.ok) throw new Error('Discount update failed');
        return response.json();
      }

      refresh(cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
      }

      async apply() {
        const code = this.input.value.trim();
        if (!code) {
          this.showError('Enter a discount code.');
          return;
        }
        this.showError('');
        this.setBusy(true);
        try {
          const existing = await this.currentCodes();
          if (existing.some((entry) => vsSameCode(entry, code))) {
            this.showError('That code is already applied.');
            return;
          }
          const cart = await this.update(existing.concat(code));
          const match = (cart.discount_codes || []).find((entry) => vsSameCode(entry.code, code));
          if (!match || !match.applicable) {
            this.showError('"' + code + '" isn\'t valid for the items in your cart.');
            await this.update(existing);
            return;
          }
          this.refresh(cart);
        } catch (error) {
          this.showError('We couldn\'t apply that code. Please try again.');
        } finally {
          this.setBusy(false);
        }
      }

      async remove(code, button) {
        button.disabled = true;
        this.showError('');
        try {
          const existing = await this.currentCodes();
          const cart = await this.update(existing.filter((entry) => !vsSameCode(entry, code)));
          this.refresh(cart);
        } catch (error) {
          button.disabled = false;
          this.showError('We couldn\'t remove that code. Please try again.');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vs-related-carousel')) {
    customElements.define('vs-related-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.dotsWrap = this.querySelector('[data-dots]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (!this.track || !this.slides.length) return;
        this.onScroll = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.build());
        this.resizeObserver.observe(this.track);
        this.build();
        this.bindDrag();
      }

      bindDrag() {
        const track = this.track;
        let startX = 0;
        let startScroll = 0;
        let active = false;
        this.dragged = false;

        track.addEventListener('dragstart', (event) => event.preventDefault());

        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          if (track.scrollWidth <= track.clientWidth) return;
          active = true;
          this.dragged = false;
          startX = event.clientX;
          startScroll = track.scrollLeft;
        });

        track.addEventListener('pointermove', (event) => {
          if (!active) return;
          const delta = event.clientX - startX;
          if (!this.dragged && Math.abs(delta) > 6) {
            this.dragged = true;
            track.setPointerCapture(event.pointerId);
            track.classList.add('is-dragging');
          }
          if (this.dragged) track.scrollLeft = startScroll - delta;
        });

        const end = () => {
          if (!active) return;
          active = false;
          if (!this.dragged) return;
          track.classList.remove('is-dragging');
          const step = this.slides[1] ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : track.clientWidth;
          track.scrollTo({ left: Math.round(track.scrollLeft / step) * step, behavior: 'smooth' });
        };
        track.addEventListener('pointerup', end);
        track.addEventListener('pointercancel', end);

        track.addEventListener('click', (event) => {
          if (!this.dragged) return;
          event.preventDefault();
          event.stopPropagation();
          this.dragged = false;
        }, true);
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      pageCount() {
        const visible = Math.max(1, Math.floor((this.track.clientWidth + 1) / this.slides[0].offsetWidth));
        return Math.max(1, this.slides.length - visible + 1);
      }

      build() {
        const count = this.track.scrollWidth > this.track.clientWidth + 2 ? this.pageCount() : 1;
        if (count === this.count) return this.update();
        this.count = count;
        this.dotsWrap.innerHTML = '';
        this.dotsWrap.hidden = count < 2;
        for (let i = 0; i < count; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'vs-related__dot';
          dot.setAttribute('aria-label', `Go to product ${i + 1}`);
          dot.addEventListener('click', () => {
            this.track.scrollTo({ left: this.slides[i].offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth' });
          });
          this.dotsWrap.appendChild(dot);
        }
        this.update();
      }

      update() {
        if (!this.count || this.count < 2) return;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const index = this.track.scrollLeft >= maxScroll - 2
          ? this.count - 1
          : Math.round(this.track.scrollLeft / (this.slides[1] ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : 1));
        Array.from(this.dotsWrap.children).forEach((dot, i) => {
          dot.setAttribute('aria-current', i === Math.min(index, this.count - 1) ? 'true' : 'false');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
